import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";
import "./Contactus.css";
import BethuaMap from './BethuaMap';
import BarniaMap from './BarniaMap';
import AddEnqueries from '../AddEnqueries';
import helmail from "../images/HELP LINE MAIL NEW.jpg";


function Contactus() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <br />
         
            <div className='nadiacloth'>
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Contact us</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <div className='backgroundcolor'>

                <div className="album py-1">
                    <div className="container">

                        <h4 className='mt-4'><b>Siddheswari Bastralaya Help Center | Customer Care Support</b></h4>
                        <p><small>​Siddheswari Bastralaya | provides customer support through their contact page. You can reach out to them for garment changes or any other queries by visiting their contact page.</small></p>
                    </div>
                </div>

            </div>

            <div className='newback'>
                <div className="album py-3">
                    <div className="container">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">BETHUADAHARI</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">BARNIA</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">ENQUERIES</button>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <br />

                                <div className="album py-0">

                                    <div className="container">

                                        <div className="row justify-content-center">

                                            <div className="col-md-5 mt-3">

                                                <h3 style={{ color: "maroon" }} className="card-text"> <b>SIDDHESWARI BASTRALAYA</b></h3>
                                                <h6 style={{ color: "maroon" }} className="card-text">Showroom Address</h6>
                                                <p style={{ color: "maroon" }} className="card-text mb-1">Patulighat Road, Bethuadahari, Nadia<br />West Bengal,

                                                    Pin 741126, India</p>

                                                <p style={{ color: "maroon" }} className="card-text"><br />Copyright © Siddheswari Bastralaya</p>

                                                <div className="d-flex justify-content-between align-items-center">

                                                </div>

                                            </div>
                                            <div className="col-md-4 mt-3">

                                                <h6 style={{ color: "maroon" }} className="card-text mb-2"> <b>CONTACT OUR SHOWROOM</b></h6>


                                                <a href="tel: 9339704703" className="btn btn- btn-light mb-2">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                                                </svg> +91 9339704703</a>

                                                <br />

                                                <ReactWhatsapp number="+91 9339704703" className="btn btn-success" message="I am Interested"> Whatsapp Contact</ReactWhatsapp>
                                                <div className="d-flex justify-content-between align-items-center">

                                                </div>

                                            </div>
                                            <div className="col-md-3 mt-3">
                                                <h6 style={{ color: "maroon" }} className="card-text "> <b>FOR BUSINESS</b></h6>
                                                <a href="tel: 9339704703" className="btn btn- btn-light mb-2">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                                                </svg> +91 9339704703</a>
                                                <a href="mailto:  help@siddheswaribastralaya.com" className="btn btn-light"> help@siddheswaribastralaya.com</a>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <BethuaMap />
                                <br />
                            </div>
                            <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                <br />
                                <div className="album py-0">

                                    <div className="container">

                                        <div className="row justify-content-center">

                                            <div className="col-md-5 mt-3">

                                                <h3 style={{ color: "maroon" }} className="card-text"> <b>SIDDHESWARI BASTRALAYA</b></h3>
                                                <h6 style={{ color: "maroon" }} className="card-text">Showroom Address</h6>
                                                <p style={{ color: "maroon" }} className="card-text mb-1">Barnia, Nadia, Pin-741156, WB

                                                    India

                                                </p>

                                                <p style={{ color: "maroon" }} className="card-text"><br />Copyright © Siddheswari Bastralaya</p>

                                                <div className="d-flex justify-content-between align-items-center">

                                                </div>

                                            </div>
                                            <div className="col-md-4 mt-3">

                                                <h6 style={{ color: "maroon" }} className="card-text mb-2"> <b>CONTACT OUR SHOWROOM</b></h6>


                                                <a href="tel: 7501148974" className="btn btn- btn-light mb-2">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                                                </svg> +91 7501148974</a>

                                                <br />

                                                <ReactWhatsapp number="+91 7501148974" className="btn btn-success" message="I am Interested"> Whatsapp Contact</ReactWhatsapp>
                                                <div className="d-flex justify-content-between align-items-center">

                                                </div>

                                            </div>
                                            <div className="col-md-3 mt-3">
                                                <h6 style={{ color: "maroon" }} className="card-text "> <b>FOR BUSINESS</b></h6>
                                                <a href="tel: 7501148974" className="btn btn- btn-light mb-2">    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                                                </svg> +91 7501148974</a>
                                                <a href="mailto:  help@siddheswaribastralaya.com" className="btn btn-light"> help@siddheswaribastralaya.com</a>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <BarniaMap/>
                            </div>
                            <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                <br/>
                                <AddEnqueries/>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>

                <br />
                <br />
            </div>

        </div>
    )
}

export default Contactus